import SearchPersonsModalView from "./searchPersonsModal.html";
import _ from 'lodash';



angular.module('notifications')

    .controller('NotificationsModalMailCtrl', ['$scope', '$uibModalInstance', '$uibModal', '$http', 'options', 'Restangular', '$filter', 'LoginService', 'Upload', 'modalService', '$stateParams', 'logService',
        function ($scope, $uibModalInstance, $uibModal, $http, options, Restangular, $filter, LoginService, Upload, modalService, $stateParams, logService) {

        $scope.mail = options;
        logService.debug(options);

        $scope.showToPart = true;
        if ($scope.mail.event_guests_ids != null || $scope.mail.persons_ids != null || $scope.mail.users_ids != null || $scope.mail.event_staffs_ids != null || $scope.mail.event_users_ids != null) {

            $scope.showToPart = false;
            $scope.totalEmails = ($scope.mail.event_guests_ids != null ? $scope.mail.event_guests_ids.length : 0) +
                ($scope.mail.persons_ids != null ? $scope.mail.persons_ids.length : 0) +
                ($scope.mail.users_ids != null ? $scope.mail.users_ids.length : 0) +
                ($scope.mail.event_staffs_ids != null ? $scope.mail.event_staffs_ids.length : 0) +
                ($scope.mail.event_users_ids != null ? $scope.mail.event_users_ids.length : 0);

        }

        $scope.message = $scope.mail.message;
        $scope.replyMailsAccounts = [];
        var user_mail = "";

        Restangular.all('MailAccounts').getList().then(function (mailsAccounts) {

            $scope.mailsAccounts = mailsAccounts;
            $scope.changeReplies(true);

        });

        //Cuenta del usuario
        Restangular.one('Users/Mail', LoginService.get("userId")).get().then(function (mail) {

            user_mail = mail;

        });


        let languageCode = "es"; //$translate.use().toLowerCase();
        $scope.tinymceOptions = {
            resize: true,
            contextmenu: false,
            branding: false,
            forced_root_block: false,
            relative_urls: false,
            convert_urls: false,
            remove_script_host: false,
            height: 100,
            body_class: 'custom_tinymce_content',
            //valid_classes: 'razor_expression',
            language: languageCode,
            paste_as_text: true,
            plugins: 'paste autoresize textcolor image lists advlist table noneditable code link fullpage',
            toolbar: "undo redo | alignleft aligncenter alignright alignjustify | bold italic forecolor backcolor fontsizeselect | bullist numlist outdent indent link",
            menubar: false,
            statusbar: false,
            setup: function (editor) {

            }
        };

        $scope.options = options;

        $scope.changeReplies = function (firstime) {

            if (typeof firstime === 'undefined') firstime = false;

            $scope.replyMailsAccounts = [];
            let reply_to = $scope.mail.mail_account_reply;
            if ($scope.mailsAccounts != null && typeof ($scope.mailsAccounts) !== 'undefined' && $scope.mail.mail_account_id != null && typeof ($scope.mail.mail_account_id) !== 'undefined') {
                $scope.replyMailsAccounts.push(_.find($scope.mailsAccounts, function (account) { return $scope.mail.mail_account_id == account.id; }).email);
                if (!firstime) reply_to = _.find($scope.mailsAccounts, function (account) { return $scope.mail.mail_account_id == account.id; }).reply_to; //solo si cambia el combo
            }
                        
            $scope.mail.from = $scope.replyMailsAccounts[0];
            $scope.mail.reply_to = reply_to;
            $scope.replyMailsAccounts.push(user_mail);

        };
        
        $scope.newAttachment = function (file) {

            if (file != null) { $scope.mail.files.unshift(file); }

        };

        $scope.deleteAttachment = function (item) {

            var index = $scope.mail.files.indexOf(item);
            $scope.mail.files.splice(index, 1);

        };

        $scope.onAccept = function () {

            if (angular.isUndefined($scope.mail.addresses)) $scope.mail.addresses = "";
            if (angular.isUndefined($scope.mail.cc_tmp)) $scope.mail.cc_tmp = "";
            if (angular.isUndefined($scope.mail.cco_tmp)) $scope.mail.cco_tmp = "";

            if ($scope.mail.addresses == "" && $scope.mail.cc_tmp == "" && $scope.mail.cco_tmp == "" && $scope.showToPart) {
                $scope.message = $filter('translate')('mail.missing_mail_to_cco_cc');
            } else {
                if (angular.isDefined($scope.mail.addresses) && $scope.mail.addresses != "" && $scope.mail.addresses != null)
                    $scope.mail.to = $scope.mail.addresses.split(",");
                if (angular.isDefined($scope.mail.cc_tmp) && $scope.mail.cc_tmp != "" && $scope.mail.cc_tmp != null)
                    $scope.mail.cc = $scope.mail.cc_tmp.split(",");
                if (angular.isDefined($scope.mail.cco_tmp) && $scope.mail.cco_tmp != "" && $scope.mail.cco_tmp != null)
                    $scope.mail.cco = $scope.mail.cco_tmp.split(",");

               if ($scope.mail.files.length > 0) {
                   Upload.base64DataUrl($scope.mail.files).then(function (urls) {
                       for (var i = 0; i < urls.length; i++) {
                           $scope.mail.attachments.push({
                               name: $scope.mail.files[i].name,
                               content: urls[i]
                           });
                       }
                       confirmSend();
                    });
               } else {
                   confirmSend();
               }
            }            
        };

        var confirmSend = function () {
            if (
                ($scope.mail.invitation_template != null && $scope.mail.invitation_template != "" && typeof $scope.mail.invitation_template != "undefined")
                ||
                ($scope.options.template != null && $scope.options.template.is_invitation)
            ) {
                //preguntamos si marcar como invitados o no
                modalService.confirm({
                    title: "",
                    message: $filter('translate')('events.guests.mark_as_sent_invitation'),
                    onAccept: function () {
                        $scope.mail.mark_as_sent_invitation = true;
                        send();
                    },
                    onCancel: function () {
                        $scope.mail.mark_as_sent_invitation = false;
                        send();
                    }
                });
            } else {
                send();
            }
        };

        var send = function () {
            $http({
                method: 'post',
                url: (window as any).CONFIG.api_url + 'NotificationsEmails/SendMail',
                data: $scope.mail
            }).success(function (results, status, headers, config) {
                $uibModalInstance.close(true);
            }).error(function (results, status, headers, config) {
            });
        };

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.openSearchPerson = function (whereToAdd) {
            let $modalInstance = $uibModal.open({
                animation: true,
                template: SearchPersonsModalView,
                size: "lg",
                controller: "searchPersonsModalCtrl",
                scope: $scope,
                resolve: {
                    options: function () {
                        return {};
                    }
                }
            });
            //Response del modal
            $modalInstance.result.then(function (data) {
                let mailsSelected = "";
                angular.forEach(data, function (row) {
                    mailsSelected = (mailsSelected != "" ? mailsSelected + "," + row : row);
                });
                if (whereToAdd == "addresses") {
                    $scope.mail.addresses = (typeof ($scope.mail.addresses) !== 'undefined' && $scope.mail.addresses != "" ? $scope.mail.addresses + "," + mailsSelected: mailsSelected);
                } else if (whereToAdd == "cc_tmp") { 
                    $scope.mail.cc_tmp = (typeof ($scope.mail.cc_tmp) !== 'undefined' && $scope.mail.cc_tmp != "" ? $scope.mail.cc_tmp + "," +mailsSelected: mailsSelected);
                } else if (whereToAdd == "cco_tmp") {
                    $scope.mail.cco_tmp = (typeof ($scope.mail.cco_tmp) !== 'undefined' && $scope.mail.cco_tmp != "" ? $scope.mail.cco_tmp + "," +mailsSelected: mailsSelected);
                }
                if (!$scope.$$phase) $scope.$apply();
            }, function () {
                console.info('Modal dismissed at: ' + new Date());
                if (!$scope.$$phase) $scope.$apply();
            });
        };

        $scope.reloadTemplate = function () {
            logService.debug("entra en el reloadTemplate");
            logService.debug(options);
            Restangular.all("NotificationsTemplates").customGET("LoadTemplate", { template_id: options.template_id }).then(function (res) {
                if (res !== "" && typeof (res) !== "undefined") {
                    $scope.mail.content = res;
                } else {
                    //options.content = template.FK_templates_tl_templates[0].html;
                    toastr.error("Ha ocurrido un error, no se encuentra el template original");
                }
            });
        }

    }])
    

;